import React from "react";
import { TicketRoutingData } from "../../data/TicketRoutingData";
import ListItem from "../ListItem/ListItem";
import { TicketsMenuStyle } from "./TicketsMenuStyle";

const TicketsMenu = () => {
  return (
    <TicketsMenuStyle>
      <ListItem items={TicketRoutingData} />
    </TicketsMenuStyle>
  );
};

export default TicketsMenu;
